<div class="container">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-sm-12 text-left">
                    <h5 class=" card-category">My Portfolio</h5>
<!--                    <h2 class=" card-title"><i class="fas fa-sync-alt"></i> Update Portfolio</h2> -->
                    <h2 class=" card-title"><span *ngIf="currentCluster"><i class="fab fa-elementor fa-lg"></i>&nbsp;&nbsp;&nbsp; Update "{{ currentCluster.name }}"</span><span *ngIf="!currentCluster"><i class="fab fa-elementor fa-lg"></i>&nbsp;&nbsp;&nbsp; Update Portfolio</span></h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">

                <div class="text-center" *ngIf="!currentCluster">
                  <h4 class="text-danger">Select a Portfolio in "Current Portfolio"</h4>
                </div>

                <div class="text-center" *ngIf="currentCluster">
                  <h4 class="text-danger" *ngIf="!hasInvestable">This portfolio can't be updated. Make it at least investable!</h4>
                  <h4 class="text-danger" *ngIf="hasInvestable && !fileUploadNeeded">This portfolio is up to date. No update needed for now!</h4>
                </div>

                <div class="text-center" *ngIf="fileUploadNeeded && currentCluster">
                  <input type="file" (change)="changeListener($event.target.files)" class="upload" accept="text/csv" hidden #componentsfile multiple>
                  <app-line-button [disabled]="disableActions" (click)="disableActions ? null : componentsfile.click()">Upload returns file</app-line-button>
                </div>

                <!-- Original -->
                <div *ngIf="fileUploadNeeded && managedOriginal && !currentCluster.is_standalone && !currentCluster.is_backtest">
                  <h4 class="card-title">Original</h4>

                  <table mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" class="card-text" style="width:80px">Automatic</th>
                        <th scope="col" class="card-text">Name</th>
                        <th *ngIf="fileUploadNeeded" scope="col" class="card-text" style="width:200px">Column</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th class="text-center" style="width:30px">
                          <mat-checkbox [checked]="!managedOriginal.original_data.is_private" [disabled]="true"></mat-checkbox>
                        </th>
                        <th class="ellipsis">
                          <app-frequency-badge [frequency]="managedOriginal.original_data.frequency_alias"></app-frequency-badge>
                          <span mdbTooltip="{{ managedOriginal.original_data.name }}">{{ managedOriginal.original_data.name }}</span>
                        </th>
                        <td *ngIf="fileUploadNeeded" style="width:200px">
                          <mat-form-field *ngIf="managedOriginal.original_data.is_private" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                            <mat-label class="card-text">Select a Column</mat-label>
                            <mat-select [(value)]="managedOriginal.updated_data" (selectionChange)="onUpdateSelectionChange()">
                              <mat-option *ngFor="let product of uploadedProducts" [value]="product">{{ product.name }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <!-- Original -->

                <!-- Benchmark -->
                <div *ngIf="fileUploadNeeded && currentCluster">
                  <h4 class="card-title">Benchmark</h4>

                  <table mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" class="card-text" style="width:80px">Automatic</th>
                        <th scope="col" class="card-text">Name</th>
                        <th *ngIf="fileUploadNeeded" scope="col" class="card-text" style="width:200px">Column</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th class="text-center" style="width:30px">
                          <mat-checkbox [checked]="!managedBenchmark.original_data.is_private" [disabled]="true"></mat-checkbox>
                        </th>
                        <th class="ellipsis">
                          <app-frequency-badge [frequency]="managedBenchmark.original_data.frequency_alias"></app-frequency-badge>
                          <span mdbTooltip="{{ managedBenchmark.original_data.name }}">{{ managedBenchmark.original_data.name }}</span>
                        </th>
                        <td *ngIf="fileUploadNeeded" style="width:200px">
                          <mat-form-field *ngIf="managedBenchmark.original_data.is_private" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                            <mat-label class="card-text">Select a Column</mat-label>
                            <mat-select [(value)]="managedBenchmark.updated_data" (selectionChange)="onUpdateSelectionChange()">
                              <mat-option *ngFor="let product of uploadedProducts" [value]="product">{{ product.name }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <!-- Benchmark -->

                <!-- Components -->
                <div *ngIf="fileUploadNeeded && currentCluster && currentCluster.nb_components>0 && !currentCluster.is_standalone">
                  <h4 class="card-title">Components</h4>

                  <table mdbTable small="true">
                    <thead>
                      <tr>
                        <th scope="col" class="card-text" style="width:80px">Automatic</th>
                        <th scope="col" class="card-text">Name</th>
                        <th *ngIf="fileUploadNeeded" scope="col" class="card-text" style="width:200px">Column</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of managedComponents">
                        <th class="text-center" style="width:30px">
                          <mat-checkbox [checked]="!component.original_data.is_private" [disabled]="true"></mat-checkbox>
                        </th>
                        <th class="ellipsis">
                          <app-frequency-badge [frequency]="component.original_data.frequency_alias"></app-frequency-badge>
                          <span mdbTooltip="{{ component.original_data.name }}">{{ component.original_data.name }}</span>
                        </th>
                        <td *ngIf="fileUploadNeeded" style="width:200px">
                          <mat-form-field class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                            <mat-label class="card-text">Select a Column</mat-label>
                            <mat-select [(value)]="component.updated_data" (selectionChange)="onUpdateSelectionChange()">
                              <mat-option *ngFor="let product of uploadedProducts" [value]="product">{{ product.name }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Components -->

              </div>

              <div *ngIf="fileUploadNeeded && currentCluster" class=" card-footer">
                <div class="col-12 text-center">
                  <app-button [disabled]="disableUpdate" (click)="onUpdate()">Update data</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>
    </div>
  </div>
